import { alpha, Button, styled } from '@/shared/ui/mui';
/**
 * GradientButton - A button with purple gradient background
 *
 * Features:
 * - Purple gradient (primary theme colors)
 * - Hover animation with shadow and lift effect
 * - Consistent with brand identity
 *
 * Usage:
 * ```tsx
 * <GradientButton onClick={handleClick}>
 *   Get Started
 * </GradientButton>
 * ```
 */
export const GradientButton = styled(Button)(({ theme }) => ({
  background: `linear-gradient(90deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
  color: theme.palette.primary.contrastText,
  fontWeight: 'bold',
  padding: '12px 24px',
  borderRadius: '12px',
  textTransform: 'none',
  fontSize: '1rem',
  boxShadow: `0 4px 14px ${alpha(theme.palette.primary.main, 0.3)}`,
  transition: 'all 0.3s ease',
  '&:hover': {
    background: `linear-gradient(90deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
    boxShadow: `0 6px 20px ${alpha(theme.palette.primary.main, 0.5)}`,
    transform: 'translateY(-2px)',
  },
  '&:disabled': {
    background: `linear-gradient(90deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
    opacity: 0.5,
  },
}));
